import {inject} from "@angular/core"
import type {CmLogger} from "@cm/log"
import {CM_LOGGER_API} from "@common/services/logging"
import {ApolloLink, HttpLink} from "@apollo/client/core"
import {setContext} from "@apollo/client/link/context"
import {onError} from "@apollo/client/link/error"
import {Settings} from "@common/models/settings/settings"
import {LocalStorageService} from "@common/services/local-storage/local-storage.service"

const uri = Settings.GQL_API_ENDPOINT

export const getHttpLink = (): ApolloLink => {
    const httpLink = new HttpLink({
        uri,
    })

    const localStorageService = inject(LocalStorageService)
    const logger: CmLogger = inject(CM_LOGGER_API)
    const headersLink = setContext((_request, previousContext) => {
        if ("withoutSilo" in previousContext) {
            return {
                headers: localStorageService.headersWithoutSilo,
            }
        } else {
            return {
                headers: localStorageService.headers,
            }
        }
    })

    const errorLink = onError(({graphQLErrors, networkError}) => {
        if (graphQLErrors) {
            graphQLErrors
                .filter((error) => !error.extensions?.["expected"])
                .map(({message, path, locations, source, originalError}) => {
                    logger.error(`${path}: ${message}`, {locations, source, originalError})
                })
        } else if (networkError) {
            if (networkError instanceof DOMException && networkError.name === "AbortError") {
                return
            }
            logger.error(`[Network error]: ${networkError}`, networkError.stack)
        }
    })

    return ApolloLink.from([headersLink, errorLink, httpLink])
}
